/* eslint-disable  */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
// import clsx from 'clsx';
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import Page from 'modules/app/components/Page';
import useFeedPosts from 'sdk/hooks/feed/useOwnFeedPosts';
import PostView from 'components/shared/PostView';
import useUser from 'sdk/hooks/user/useProfile';
import styles from './UserVideos.module.scss';

function UserVideos() {
  const { data: profile } = useUser()
  const navigate = useNavigate()
  const { data } = useFeedPosts('', 20)
  const [activePostId, setActivePostId] = useState('')
  // @ts-ignore
  const posts = (data?.pages?.length ? data?.pages[0].results : [])

  useEffect(() => {
    if (posts?.length) {
      setActivePostId(posts[0]?.id)
    }
  }, [posts])

  if (!posts.length) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <h2 onClick={() => navigate(-1)}>
          <IconArrowRight />
          Videos
        </h2>
      </div>
      <div className={styles.playlistPosts}>
        {posts.map((post: any, idx) => (
          <div className={styles.postView} onMouseEnter={() => setActivePostId(post?.id)} onMouseLeave={() => setActivePostId('')}>
            <PostView
              key={post?.id}
              feedId={profile?.id}
              feedName="user"
              data={post}
              size={posts.length}
              gridItemSize={(idx === 1) ? 'large' : 'small'}
              grid={(posts?.length > 3) && true}
              style={null}
              isActive={post?.id === activePostId}
            />
          </div>

        ))}
      </div>
    </div>
  )
}

function UserVideosPage() {
  return (
    <Page activeLink="/user-videos">
      <UserVideos />
    </Page>
  )
}

export default UserVideosPage
